// Styles
export const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    overflow: 'auto'
};

export const modalStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    width: '500px',
    display: 'table',
    boxShadow: '0px 0px 10px #cccccc'
};

export const alertStyle = {
    background: '#fff1e4',
    padding: '10px',
    lineHeight: '16px',
    marginRight: '5px'
}
